import { createFileRoute } from '@tanstack/react-router';

import { NonToxicStep } from '@/features/onboarding/components/steps/nonToxic/nonToxicStep';

export const Route = createFileRoute('/_protected/onboarding/_steps/non-toxic')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <NonToxicStep />;
}
